import chunk from "lodash/chunk";

export function itemsToPages<T>(items: readonly T[], itemsPerPage: number): T[][] {
    return chunk(items, itemsPerPage);
}

/**
 * records the scroll position of a given element scoped to org and app to sessionStorage
 *
 * @export
 * @param {string} orgId
 * @param {string} appId
 */
export function setScrollPosition(key: string, scrollTop: number): void {
    if (sessionStorage) {
        sessionStorage.setItem(`stentor_scroll_position-${key}`, scrollTop.toString());
    }
}

/**
 * retrieves the scroll position saved in sessionStorage
 *
 * @export
 * @param {string} orgId
 * @param {string} appId
 * @returns {number}
 */
export function getScrollPosition(key: string): number {
    if (sessionStorage && sessionStorage.getItem(`stentor_scroll_position-${key}`)) {
        return parseInt(sessionStorage.getItem(`stentor_scroll_position-${key}`), 10);
    }
}
